import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Stack,
  Group,
  MultiSelect,
  Paper,
  Select,
} from '@mantine/core';
import HistoryBillingTable from '../components/table/HistoryBillingTable.tsx';
import useHistoryBillings from '../hooks/useHistoryBillings.ts';
import { useBillingFilter } from '../hooks/useBillingFilter.tsx';
import { uniqueByKeys } from '../utils/array.ts';
import { IconFilterCancel } from '@tabler/icons-react';

export default function HistoryBillingPage() {
  const [selectedProviders, setSelectedProviders] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState<
    'LAST_1_MONTH' | 'LAST_3_MONTHS' | 'LAST_6_MONTHS' | 'LAST_1_YEAR'
  >('LAST_6_MONTHS');

  const { isLoading, data = [] } = useHistoryBillings(selectedPeriod);
  const { filteredData, handleFilter } = useBillingFilter(data);

  useEffect(() => {
    handleFilter({ selectedProviders, selectedTags });
  }, [selectedProviders, selectedTags, handleFilter]);

  // 清除所有篩選
  const handleClear = () => {
    setSelectedProviders([]);
    setSelectedTags([]);
  };

  const siteProviders = uniqueByKeys(
    data.map((x) => x.siteProvider),
    ['id'],
  );
  const tags = [...new Set(data.flatMap((x) => x.tags.map((tag) => tag.name)))];

  return (
    <Paper p="xl" radius="lg" shadow="xl" mb="xl">
      <Stack gap="xl">
        <Box pos="relative">
          <Group>
            <MultiSelect
              label="廠商"
              placeholder="全部"
              data={siteProviders.map((v) => ({ value: v.id, label: v.name }))}
              value={selectedProviders}
              onChange={setSelectedProviders}
              searchable
              clearable
            />
            <MultiSelect
              label="標籤"
              placeholder="全部"
              data={tags.map((tag) => ({ value: tag, label: tag }))}
              value={selectedTags}
              onChange={setSelectedTags}
              searchable
              clearable
            />
            <Select
              label="對帳期間範圍"
              data={[
                { value: 'LAST_1_MONTH', label: '最近一個月' },
                { value: 'LAST_3_MONTHS', label: '最近三個月' },
                { value: 'LAST_6_MONTHS', label: '最近六個月' },
                { value: 'LAST_1_YEAR', label: '最近一年' },
              ]}
              value={selectedPeriod}
              // @ts-expect-error 後面是 enum 限制所以 string 會有型別檢查錯誤
              onChange={setSelectedPeriod}
            />
          </Group>
          <Box pos="absolute" top={0} right={0}>
            <Button
              variant="outline"
              size="xs"
              onClick={handleClear}
              leftSection={<IconFilterCancel size={14} />}
            >
              清除篩選
            </Button>
          </Box>
        </Box>
        <HistoryBillingTable data={filteredData} isLoading={isLoading} />
      </Stack>
    </Paper>
  );
}
